import { useMutateImportAndValidatePriorities } from '@retail/my-assortment/data-access';
import { AssortmentItemImportResultDTO, AssortmentItemUpload } from '@retail/my-assortment/types';
import { useEffect } from 'react';

interface Props {
  importedItems: AssortmentItemUpload[];
  assortmentId: number;
  setValidationState: (state: AssortmentItemImportResultDTO[]) => void;
}

export const useAssortmentValidation = ({
  importedItems,
  assortmentId,
  setValidationState,
}: Props) => {
  const {
    mutateAsync: validateItemsAsync,
    isPending: loadingValidateItems,
    isError: failedValidation,
  } = useMutateImportAndValidatePriorities({ assortmentId });

  useEffect(() => {
    if (importedItems.length > 0) {
      validateItemsAsync({
        body: importedItems,
      }).then((res) => setValidationState(res));
    }
  }, [importedItems, importedItems.length, setValidationState, validateItemsAsync]);

  return {
    loadingValidateItems,
    failedValidation,
  };
};
